import type { AssetTechnicalUpdateHistoryProps } from "./asset-technical-update-history.type";

import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { format, toCalendar } from "@/utilities/date";

const AssetTechnicalUpdateHistory = ({
  lastTechnicalUpdate,
}: AssetTechnicalUpdateHistoryProps) => {
  const { t } = useTranslation();
  const updatedBy = lastTechnicalUpdate.updated_by
    ? t("asset:technical.lastUpdateBy", {
        user: lastTechnicalUpdate.updated_by,
      })
    : "";

  return (
    <Tooltip title={format(lastTechnicalUpdate.updated_at, "LLLL")}>
      {`${t("asset:technical.lastUpdate", {
        date: toCalendar(lastTechnicalUpdate.updated_at)?.toLowerCase(),
      })} ${updatedBy}`}
    </Tooltip>
  );
};

export default AssetTechnicalUpdateHistory;
